import QrScanner from "qr-scanner";
import QrScannerWorkerPath from "qr-scanner/qr-scanner-worker.min.js?url";
QrScanner.WORKER_PATH = QrScannerWorkerPath;

let scanner: QrScanner | null = null;

export async function scanQR(video: HTMLVideoElement) {
    return new Promise((resolve, reject) => {
        scanner && scanner.stop();
        scanner = new QrScanner(video, (res) => {
            scanner && scanner.stop();
            resolve(res);
            scanner = null;
        });

        scanner.start().then(
            () => {},
            (err) => reject(err)
        );
    });
}

export function stopScanQR() {
    scanner && scanner.stop();
    scanner = null;
}
